import React, { useState,useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './index.scss';
import LeadsDashboard from '../../BarChartWithCards';
import backicon from './../../../../../Assets/icons/backIcon.svg'
import { Modal } from 'react-bootstrap';
import axiosInstance from '../../../../services/api/API';
import TotalCounts from '../../TotalCounts';
import SalesPerformance from '../../SalesPerformance';
import { toastError } from '../../../../customComponents/customToast/Toast';
import ActionToBeTaken from '../../AdvanceSearch/ActionToBeTaken';
import Swal from 'sweetalert2';
const FollowUpRequiredDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');
  const followUplead_id = location?.state?.data
  const lead_id = location?.state?.data?.lead_id
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [selectedAssignee, setSelectedAssignee] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [leaddetails,setLeadDetails] = useState([])
  const [transactionDetails, setTransactionDetails] = useState([]);
  const [showRemarkModal, setShowRemarkModal] = useState(false); 
  const [remark, setRemark] = useState('');
  const [assigneeList,setAssigneeList] = useState([]);
  const businessPartnerId=localStorage.getItem("business_partner_id");
  const authToken = localStorage.getItem("authToken");
  const [filteredAssigneeList, setFilteredAssigneeList] = useState(assigneeList);

  useEffect(() => {
    axiosInstance.get(`/lead/lead-details/${lead_id?lead_id:followUplead_id}`)
      .then(response => {
        setLeadDetails(response.data?.data?.data[0]);
      })
      .catch(error => {
        console.error('Error fetching lead details:', error);
      });
    axiosInstance.post('/lead/lead-transaction-details',{
      lead_id:lead_id?lead_id:followUplead_id,
      orderBy:"leadtr_id desc",
      page:0,
      pageSize:10
    })
      .then(response => {
       setTransactionDetails(response.data.data.data);
      })
      .catch(error => {
        console.error('Error fetching assignee list:', error);
      });
  }, [id]);
  const LeadDetails =()=>{
     axiosInstance.get(`/lead/lead-details/${lead_id?lead_id:followUplead_id}`)
     .then(response => {
       setLeadDetails(response.data?.data?.data[0]);
     })
     .catch(error => {
       console.error('Error fetching lead details:', error);
     });
  }
  

   useEffect(() => {
    if (modalType) {
      fetchAssigneeList();
    }
  }, [modalType]);

  const fetchAssigneeList = async () => {
    console.log("modalType>>",modalType);
    try {
      const endpoint = modalType === 'Telecaller' ? '/user/ddltelecaller' : '/dealer/ddlDealer';
      const response = await axiosInstance.post(
        endpoint,
        { business_partner_id: businessPartnerId ==="0"?null:businessPartnerId},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const assignees = response.data.data.data.map(assignee => ({
        name: assignee.NAME,
        id: assignee.ID,
        assignedLeads: assignee.assignedcount,
      }));
      setAssigneeList(assignees);
      setFilteredAssigneeList(assignees);
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to fetch assignees. Please try again.";
      toastError(errorMessage);
      console.error("Error fetching assignees:", error);
    }
  };
  const handleSearchChange = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    const filteredList = filteredAssignees.filter(assignee =>
      assignee.name.toLowerCase().includes(value)
    );
    console.log("modalsearch",value);
    setFilteredAssigneeList(filteredList);
  };

  const handleAssignClick = (type) => {
    console.log("modaltype",type);
    
    setModalType(type);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedAssignee('');
  };

  const handleAssigneeChange = (event) => {
    console.log("event>>",event.target.value);
    setSelectedAssignee(Number(event.target.value));
    console.log(" ",selectedAssignee);
  };
  const handleAssign = async () => {
    // Show confirmation alert before proceeding
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to assign this lead?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
       // Optional: puts the cancel button on the left side
    }).then(async (result) => {
      if (result.isConfirmed) {
        // User confirmed, proceed with the assignment
        console.log(`Assigning ${modalType} to ${selectedAssignee}`);
        const assigneeId = selectedAssignee;
        console.log("assigneeId", assigneeId, modalType, selectedLeadId);
  
        try {
          const response = await axiosInstance.post(
            "/presale/assignlead",
            {
              assigntype: modalType.toLowerCase().replace(" ", ""),
              [`${modalType.toLowerCase().replace(" ", "")}_id`]: assigneeId,
              lead_id: String(lead_id) || String(followUplead_id),
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            }
          );
  
          setShowModal(false); // Close the modal
          fetchAssigneeList(); // Fetch the updated list
          LeadDetails(); // Fetch updated lead details
  
          // Display SweetAlert success message
          Swal.fire({
            title: "Success!",
            text: `Lead assigned successfully.`,
            icon: "success",
            confirmButtonText: "OK",
          });
        } catch (error) {
          const errorMessage = error.response?.data?.message || "Failed to assign lead. Please try again.";
  
          // Display SweetAlert error message
          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
  
        setShowModal(false);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // User canceled, show a message or simply exit
        Swal.fire({
          title: "Cancelled",
          text: "Assignment operation was cancelled.",
          icon: "info",
          confirmButtonText: "OK",
        });
      }
    });
  };
  

  // const handleAssign =async () => {
  //   console.log(`Assigning ${modalType} to ${selectedAssignee}`);
  //   const assigneeId = selectedAssignee;
  //   console.log("assigneeId",assigneeId,modalType,selectedLeadId);
  //   try {
  //     await axiosInstance.post(
  //       "/presale/assignlead",
  //       {
  //         assigntype: modalType.toLowerCase().replace(" ", ""),
  //         [`${modalType.toLowerCase().replace(" ", "")}_id`]: assigneeId,
  //         lead_id: String(lead_id) || String(followUplead_id)
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         }
  //       }
  //     );
  //     setShowModal(false);
  //     fetchAssigneeList()
  //     LeadDetails();
  //   } catch (error) {
  //     const errorMessage = error.response?.data?.message || "Failed to assign lead. Please try again.";
  //   }
  //   setShowModal(false);
  // };
  const handleCloseRemarkModal = () => {
    setShowRemarkModal(false);
  };

  const handleSaveRemark = () => {
    console.log('Remark:', remark);
    setShowRemarkModal(false);
  };
   const fetchTransactionDetails = () => {
    axiosInstance.post('/lead/lead-transaction-details', {
      lead_id: lead_id?lead_id:followUplead_id,
      orderBy: "leadtr_id desc",
      page: 0,
      pageSize: 10
    })
    .then(response => {
      setTransactionDetails(response.data.data.data);
    })
    .catch(error => {
      console.error('Error fetching transaction details:', error);
    });
  };

  useEffect(() => {
    axiosInstance.get(`/lead/lead-details/${lead_id ? lead_id : followUplead_id}`)
      .then(response => {
        setLeadDetails(response.data?.data?.data[0]);
      })
      .catch(error => {
        console.error('Error fetching lead details:', error);
      });

 
    fetchTransactionDetails();
  }, [id]);

  const assigneeTypeFilter = modalType === 'Telecaller' ? 'Telecaller' : 'Sales Manager';
  const filteredAssignees = assigneeList.filter(assignee => assignee.name.includes(assigneeTypeFilter));

  return (
    <div>
      <div className='OnboardManagamentContainer row'>
        <TotalCounts title={"Lead Details"} />
     
      </div>

    

      <div className="lead-details-container">
        <div className="headerwithbtns">
        <div className="backbutton col-lg-3 mt-2 mb-2" onClick={()=>navigate(-1)}>
        <img src={backicon} alt="back"  />
        <span className="backbtntitle">Lead Details</span>
       
      </div>
      <div className="details-actions-presale col-lg-9 mt-2 mb-3">
          <button className='action-button' onClick={() => handleAssignClick('Telecaller')}>Assign Telecaller</button>
          {/* <button className='action-button' onClick={() => handleAssignClick('Sales Manager')}>Assign Sales Manager</button> */}
          <button className='action-button ' onClick={() => console.log('Call Now')}>Call Now</button>
         
        </div>
        </div>
     
        <div className="lead-details-section">
          <h5>Personal Details</h5>
          <div className="lead-details-grid">
            <div className="details-item">
              <span className="details-label">Lead Code</span>
              <span className="details-value">{leaddetails?.lead_code}</span>
            </div>
            <div className="details-item">
              <span className="details-label">Customer Name:</span>
              <span className="details-value">{leaddetails?.full_name}</span>
            </div>
            <div className="details-item">
              <span className="details-label">Phone No.:</span>
              <span className="details-value">{leaddetails?.mobile_no}</span>
            </div>
            <div className="details-item">
              <span className="details-label">Email Address:</span>
              <span className="details-value">{leaddetails?.email_id?leaddetails?.email_id:'-'}</span>
            </div>
            <div className="details-item">
              <span className="details-label">Address:</span>
              <span className="details-value">{leaddetails?.address?leaddetails?.address:'-'}</span>
            </div>
            <div className="details-item">
              <span className="details-label">Inquiry Date:</span>
              <span className="details-value">{leaddetails?.created_at}</span>
            </div>
            <div className="details-item">
              <span className="details-label">Lead Status:</span>
              <span className="details-value">{leaddetails?.status_name}</span>
            </div>
            <div className="details-item">
              <span className="details-label">Sales Manager:</span>
              <span className="details-value">{leaddetails?.salesmanagername||"-"}</span>
            </div>
          </div>
        </div>
        <div className="lead-details-section">
          <h5>Product Details</h5>
          <div className="lead-details-grid">
            <div className="details-item">
              <span className="details-label">Product Name:</span>
              <span className="details-value">{leaddetails?.product_name?leaddetails?.product_name:'-'}</span>
            </div>
            <div className="details-item">
              <span className="details-label">Make:</span>
              <span className="details-value">{leaddetails?.make_name?leaddetails?.make_name:'-'}</span>
            </div>
            <div className="details-item">
              <span className="details-label">Model:</span>
              <span className="details-value">{leaddetails?.model_name?leaddetails?.model_name:'-'}</span>
            </div>
            <div className="details-item">
              <span className="details-label">Variant:</span>
              <span className="details-value">{leaddetails?.variant_name?leaddetails?.variant_name
              :'-'}</span>
            </div>
            <div className="details-item">
              <span className="details-label">Color:</span>
              <span className="details-value">{leaddetails?.color_name?leaddetails?.color_name:'-'}</span>
            </div>
          </div>
        </div>
        
        <div className="lead-details-section">
          <div className='transactionform'><ActionToBeTaken onActionSubmitted={fetchTransactionDetails} /></div>
          <h5 className='fodetailshead' >Follow-up Details</h5>

{/* Header Row */}
<div className="lead-details-grid header-row">
  <div className="details-item header-item-presales">
    <span className="details-label">Tele Caller Name</span>
  </div>
  <div className="details-item header-item-presales">
    <span className="details-label">Call Disposition</span>
  </div>
  <div className="details-item header-item-presales">
    <span className="details-label">Action To Be Taken Date</span>
  </div>
  <div className="details-item header-item-presales">
    <span className="details-label">Action Taken</span>
  </div>
  <div className="details-item header-item-presales">
    <span className="details-label">Follow Up Date</span>
  </div>

  <div className="details-item header-item-presales">
    <span className="details-label">Remark</span>
  </div>
</div>

{/* Content Rows */}
{transactionDetails.map((detail, index) => (
  <div className="lead-details-grid" key={index}>
    <div className="details-item">
      <span className="details-value">{detail.telecaller_name}</span>
    </div>
    <div className="details-item">
      <span className="details-value">{detail.action_tobe_taken_name}</span>
    </div>
    <div className="details-item">
      <span className="details-value">{detail.action_tobe_taken_datetime}</span>
    </div>
    <div className="details-item">
      <span className="details-value">{detail.action_taken_name}</span>
    </div>
    <div className="details-item">
      <span className="details-value">{detail.follow_up_date ? detail.follow_up_date : "-"}</span>
    </div>
  </div>
))}
        </div>
       
      </div>

      {showModal && (
        <Modal isPresales={true} show={showModal} onHide={handleModalClose} centered>
          <span className='modalheading'>Select {modalType}</span>
          <input
            type="text"
            placeholder="Search"
            className="leadmodalsearch mt-2 mb-2"
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <div className="assignee-list">
          {filteredAssigneeList.map((assignee, index) => (
              <div key={index} className="assignee-item mt-2">
                <label htmlFor={`assignee-${index}`}>{assignee.name}</label>
                <div className='countcontainer'>
                  <label htmlFor={`assignee-${index}`} className='counttotal'> {assignee.assignedLeads} leads Assigned</label>
                  <input
                    type="radio"
                    style={{height:20,width:20}}
                    name="assignee"
                    value={assignee.id }
                    onChange={handleAssigneeChange}
                    checked={selectedAssignee === assignee.id}
                  />
                </div>
              </div>
            ))}
          </div>
          <div className='modalbuttons mt-2 mb-2'>
            <button onClick={handleModalClose} className='leadbtn'>Cancel</button>
            <button onClick={handleAssign} className='leadbtn'>Assign </button>
          </div>
        </Modal>
      )}

      {showRemarkModal && (
        <Modal show={showRemarkModal} onHide={handleCloseRemarkModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Add Remark</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <textarea
              rows="4"
              className="form-control"
              placeholder="Enter your remark here..."
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Modal.Body>
          <Modal.Footer>
            <button className='btn btn-secondary' onClick={handleCloseRemarkModal}>Cancel</button>
            <button className='btn btn-primary' onClick={handleSaveRemark}>Save Remark</button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default FollowUpRequiredDetails;
